/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import { Modal, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import { ModalProps } from 'antd/lib/modal';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { TagsTab } from './RightsModal/Tabs/TagsTab';
import { TenderTab } from './RightsModal/Tabs/TenderTab';
import { LabelsTab } from './RightsModal/Tabs/LabelsTab';
import { ModulesTab } from './RightsModal/Tabs/ModulesTab';
import { useArchiveSettings } from '~src/hooks/api-hooks/useArchiveSettings';
import { useIsSuperuser } from '~src/hooks/useIsSuperuser';

export const ProjectSettingsModal: React.FC<ModalProps> = ({
  onCancel,
  afterClose,
  projectData,
  ...modalProps
}) => {
  const intl = useIntl();
  const archiveSettings = useArchiveSettings();
  const isSuperuser = useIsSuperuser();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on;
  const isTenderAdmin = projectData?.is_tender_admin;

  const [activeTab, setActiveTab] = useState('tags');

  return (
    <Modal
      okButtonProps={{ hidden: true }}
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'project-settings' })}
          icon={['far', 'cog']}
        />
      }
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={activeTab === 'labels' ? 'min(90vw, 800px)' : 'min(75vw, 450px)'}
      bodyStyle={{ padding: '25px 25px 0 25px' }}
      centered
      destroyOnClose
      maskClosable={false}
      onCancel={onCancel}
      footer={
        window.sessionStorage.getItem('appState') !== 'timeMachine' && undefined
      }
      {...modalProps}>
      <Tabs
        style={{ marginTop: -40 }}
        activeKey={activeTab}
        onChange={setActiveTab}>
        <Tabs.TabPane
          style={{ marginTop: 8 }}
          key="tags"
          tab={intl.formatMessage({ id: 'tags' })}>
          <TagsTab />
        </Tabs.TabPane>
        {(isTenderingOn || isTenderAdmin) && (
          <Tabs.TabPane
            style={{ marginTop: 8 }}
            key="labels"
            tab={intl.formatMessage({ id: 'labels' })}>
            <LabelsTab />
          </Tabs.TabPane>
        )}
        {(isTenderingOn || isTenderAdmin) && (
          <Tabs.TabPane
            style={{ marginTop: 8 }}
            key="tender"
            tab={intl.formatMessage({ id: 'tender' })}>
            <TenderTab projectData={projectData} />
          </Tabs.TabPane>
        )}
        {isSuperuser && (
          <Tabs.TabPane
            style={{ marginTop: 8 }}
            key="modules"
            tab={intl.formatMessage({ id: 'modules' })}>
            <ModulesTab />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Modal>
  );
};
